export default __webpack_public_path__ + "static/media/ad_preview_display_empty.c68f3328.svg";